/** Хелперы для построения NATS envelope (CommandMessage / QueryMessage). */

export type TenantIdProvider = () => string

// Дефолт до инициализации приложением. Реальный tenant задаёт потребитель
// через setTenantIdProvider — пакет про auth-store/Pinia не знает.
let tenantIdProvider: TenantIdProvider = () => 'system'

/**
 * Задать источник tenantId для envelope. Приложение обязано вызвать это на
 * bootstrap ДО первого запроса в шину (apps/ui — boot/nats.ts из auth-store;
 * встраиваемая панель — из claims своего JWT). Провайдер читается при каждом
 * построении envelope — смена тенанта после релогина подхватывается сама.
 */
export const setTenantIdProvider = (provider: TenantIdProvider): void => {
  tenantIdProvider = provider
}

export const buildCommand = (type: string, payload: Record<string, unknown> = {}) => ({
  type,
  version: 1,
  commandId: crypto.randomUUID(),
  tenantId: tenantIdProvider(),
  timestamp: new Date().toISOString(),
  ...payload,
})

export const buildQuery = (type: string, payload: Record<string, unknown> = {}) => ({
  type,
  version: 1,
  queryId: crypto.randomUUID(),
  tenantId: tenantIdProvider(),
  timestamp: new Date().toISOString(),
  ...payload,
})
